// extracted by mini-css-extract-plugin
module.exports = {"Link":"Project_Link__1k9-M","teamMembers":"Project_teamMembers__2xkZJ","copyLink":"Project_copyLink__MN0bz"};